/* ============================================================================
   VANGUARD PRODUCT SYSTEM — v-sticky-atc.js
   ----------------------------------------------------------------------------
   Muestra la barra de compra fija solo a partir del segundo bloque, es decir
   cuando el Hero ha salido de pantalla. Mientras el Hero se ve, su propio CTA
   ya está a la vista y repetirlo abajo solo añade ruido.

   Se resuelve con IntersectionObserver sobre la sección del Hero, no con
   listeners de scroll: el navegador hace el cálculo fuera del hilo principal
   y no hay trabajo en cada píxel desplazado.

   MEJORA PROGRESIVA: la clase que oculta la barra la añade este script. Sin
   JS, o si no hay IntersectionObserver, la barra queda visible siempre, que
   es el comportamiento anterior y nunca deja al usuario sin CTA.
   ============================================================================ */

(function () {
  'use strict';

  function initStickyAtc() {
    var bar = document.querySelector('.v-product-sticky');
    if (!bar) return;

    var hero = document.querySelector('.v-product-hero');

    // Sin Hero que observar o sin soporte: se deja visible.
    if (!hero || typeof window.IntersectionObserver !== 'function') return;

    bar.classList.add('v-product-sticky--auto');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          // Visible solo cuando el Hero ya no está en pantalla.
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );

    observer.observe(hero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc);
  } else {
    initStickyAtc();
  }

  document.addEventListener('shopify:section:load', function () {
    initStickyAtc();
  });
})();
